import { matchPath } from "react-router";
import { appRoutes } from "@/app/router";
import { AppStore } from "@/store";
import { MDSCollectionIcon, MDSIconKind } from "@/mds";
import { AudioCaptureWaveForm } from "@/components/layout/components/audio-capture";

export const getPathIcon = (path: string, store: AppStore): MDSIconKind | React.ReactNode => {
  const noteIdMatch = matchPath(
    appRoutes.notesView({ params: { noteId: ":noteId" }, starPattern: true }),
    path
  );
  if (noteIdMatch?.params.noteId === store.audio.activeRecordingNoteId)
    return <AudioCaptureWaveForm associatedNoteId={store.audio.activeRecordingNoteId} />;

  const collectionIdMatch = matchPath(
    appRoutes.collectionsView({ params: { collectionId: ":collectionId" }, starPattern: true }),
    path
  );
  const collectionId = collectionIdMatch?.params.collectionId;
  if (collectionId) return <MDSCollectionIcon size={10} collectionId={collectionId} />;

  if (path.startsWith(appRoutes.search({}).path)) return MDSIconKind.Search;
  if (path === appRoutes.notesList({}).path) return MDSIconKind.Notebook;
  if (path === appRoutes.collections({}).path) return MDSIconKind.Collection;
  if (path === appRoutes.templatesList({}).path) return MDSIconKind.Template;
  if (path.startsWith(appRoutes.integrations({}).path)) return MDSIconKind.BoltOutline;
  if (path.startsWith(appRoutes.settings({}).path)) return MDSIconKind.Settings;
  if (path === appRoutes.trash({}).path) return MDSIconKind.Trash;
  return null;
};
